import { render, staticRenderFns } from "./SellerProductForm.vue?vue&type=template&id=3e63abb4&scoped=true"
import script from "./SellerProductForm.vue?vue&type=script&lang=js"
export * from "./SellerProductForm.vue?vue&type=script&lang=js"
import style0 from "./SellerProductForm.vue?vue&type=style&index=0&id=3e63abb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e63abb4",
  null
  
)

export default component.exports